import { COLORS } from './theme'

export const inputSx = {
  borderRadius: 1,
  backgroundColor: COLORS.white,
  '&:hover .MuiOutlinedInput-notchedOutline': {
    borderColor: COLORS.primary,
  },
  '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
    borderColor: COLORS.primary,
    borderWidth: 2,
  },
  '& .MuiOutlinedInput-notchedOutline': {
    borderColor: COLORS.secondary,
  },
} as const

export const textFieldSx = {
  '& .MuiInputBase-root': { fontSize: '16px' },
  '& .MuiInputLabel-root.Mui-focused': { color: COLORS.primary },
  '& .MuiFormHelperText-root': {
    fontSize: '14px',
    color: COLORS.subtleText,
    mt: 1,
  },
} as const

/** Shared sx for contained primary buttons used across onboarding. */
export const primaryButtonSx = {
  borderRadius: 3,
  bgcolor: COLORS.primary,
  color: 'white',
  textTransform: 'none',
  boxShadow: 'none',
  '&:hover': { bgcolor: COLORS.primaryHover, boxShadow: 'none' },
} as const

/** Shared sx for outlined buttons used across onboarding. */
export const outlinedButtonSx = {
  borderRadius: 3,
  borderColor: COLORS.primary,
  border: 2,
  color: COLORS.primary,
  textTransform: 'none',
  '&:focus': { backgroundColor: COLORS.focusBg },
} as const

export const stepHeadingSx = {
  fontWeight: 600,
  color: COLORS.primary,
  mb: 1,
} as const

export const stepDescriptionSx = {
  color: COLORS.secondary,
  mb: 3,
} as const

export const formLabelSx = {
  mb: 1,
  fontWeight: 500,
  color: COLORS.labelText,
  fontSize: '1rem',
  display: 'block',
} as const

export const checkboxSx = {
  color: COLORS.primary,
  '&.Mui-checked': { color: COLORS.primary },
} as const

export const warningBoxSx = {
  bgcolor: COLORS.warningBg,
  border: `1px solid ${COLORS.warningBorder}`,
  borderRadius: 2,
  p: 2,
} as const
